<template>
  <v-app dark warning>
      <v-content class="page-content">
        <v-container fluid>
          <div v-if="alert.message" :class="`alert ${alert.type}`">{{alert.message}}</div>
          <headernav v-if="this.$store.getters['authentication/isAuthentificated']"></headernav>
          <router-view></router-view>
          <!-- modal -->
          <newproject v-if="this.$store.getters['authentication/isAuthentificated']"></newproject>
          <modal-notif ></modal-notif>
        </v-container>
      </v-content>
  </v-app>
</template>

<script>
import headernav from "@/components/layouts/header.vue";
import newproject from "@/components/modals-form/modal-newproject.vue";
import modalNotif from "@/components/modals-form/modal-notif.vue"

export default {
  name: "app",
  components: {
    headernav,
    newproject,
    modalNotif
  },
  computed: {
    alert() {
      return this.$store.state.alert;
    },
    language() {
      if (this.$store.getters['users/getProfile'])
        return this.$store.getters['users/getProfile'].language || 'EN';
      return 'EN';
    }
  },
  watch: {
    $route(to, from) {
      // clear alert on location change
      this.$store.dispatch("alert/clear");
    },
    language(lang) {
      this.$i18n.locale = lang;
    }
  },
  mounted() {
    window.addEventListener('selectstart', (e) => e.preventDefault());
  },
  beforeCreate() {
    this.$store.dispatch("users/getProfile").then((profile) => {
      this.$i18n.locale = profile.language;
    });
  },
};
</script>
<style lang="scss">
$title-color: #8d8d8d;
$title-color-2: #bcbdbc;
@import "~bootstrap/dist/css/bootstrap.css";
.double-buttons {
  width: 400px;
  margin: auto;
  position: absolute;
  bottom: 60px;
  right: 60px;
  display: flex;
  justify-content: space-between;
}

.page-content {
  min-height: 100vh;
  background: #171717 !important;
  // padding-bottom: calc(32px + 70px) !important;
  padding-bottom: 36px !important;
}
.page-content>.v-content__wrap>.container.fluid {
  height: 100%
}
button:focus {
  outline: 0 !important;
  box-shadow: none !important;
}
.headline {
  color: #bcbdbc;
}
.float-left {
  float: left;
}

// scrollbar
::-webkit-scrollbar {
  width: 5px;
}
/* Track */
::-webkit-scrollbar-track {
  box-shadow: 0 0 2px black; 
  border-radius: 0px;
}
/* Handle */
::-webkit-scrollbar-thumb {
  background: #f1e341;
  // background: #ef7441; 
  border-radius: 0px;
}


// global css accord
.content-svg-shadow svg{
  transition: filter ease .3s;
}
.content-svg-shadow:hover svg {
  filter: drop-shadow( 3px 3px 5px rgba(0, 0, 0, .6));
}
.blue-hover {
  transition: color ease .3s;
}
.blue-hover:hover {
  color: #77edaf !important;
}
.no-outline {
  outline: none !important;
}
h1 {
  text-transform: uppercase;
  color: $title-color;
  font-size: 2rem;
  text-align: center;
  margin-top: 2rem;
}
hr {
  background-color: $title-color;
  height: 1px;
}
.subheader {
  color: $title-color-2;
  font-weight: 400;
  margin-bottom: 2rem;
}
.v-card__actions.center {
  justify-content: center;
}

// COL 2-of-10
@media (min-width: 960px) {
  .flex.md-2-of-10 {
    flex-basis: 20%;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    max-width: 20%;
  }
}
@media (min-width: 0) {
  .flex.xs-2-of-10 {
    flex-basis: 20%;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    max-width: 20%;
  }
}
@media (min-width: 1264px) {
  .flex.lg-2-of-10 {
    flex-basis: 20%;
    -webkit-box-flex: 0;
    -ms-flex-positive: 0;
    flex-grow: 0;
    max-width: 20%;
  }
}
// PADDING
.px-6 {
  padding-right: 4rem !important;
  padding-left: 4rem !important;
}
</style>
